import { Outlet } from "react-router";
import { MailOutlined, LockOutlined, StarFilled, HeartFilled } from "@ant-design/icons";

const AuthLayout = () => {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-gradient-to-br from-blue-50 to-blue-50">
      {/* Left Side - Illustration */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden items-center justify-center p-12">
        {/* Decorative Elements */}
        <div className="absolute top-20 left-20 text-yellow-400 text-2xl">
          <StarFilled />
        </div>
        <div className="absolute top-32 right-32 text-red-500 text-xl">
          <HeartFilled />
        </div>
        <div className="absolute bottom-40 left-40 text-yellow-400 text-3xl">
          <StarFilled />
        </div>
        <div className="absolute top-40 right-20 opacity-20 text-gray-400 text-6xl">
          👍
        </div>
        <div className="absolute bottom-32 right-24 text-red-500 text-xl">
          <HeartFilled />
        </div>
        
        {/* Main Illustration Area */}
        <div className="relative z-10 text-center">
          <div className="flex items-center justify-center gap-8 mb-8">
            {/* Phone Mockup */}
            <div className="bg-gray-800 rounded-3xl p-4 shadow-2xl transform -rotate-6">
              <div className="bg-white rounded-2xl p-6 w-48 h-80 flex flex-col items-center justify-center">
                <div className="text-yellow-400 text-4xl mb-4">
                  <StarFilled />
                </div>
                <div className="flex gap-1 mb-2">
                  {[1,2,3,4,5].map(i => (
                    <StarFilled key={i} className="text-yellow-400 text-sm" />
                  ))}
                </div>
                <div className="text-gray-300 text-xs">★ ★ ★ ★ ★</div>
              </div>
            </div>
            
            {/* Person 1 */}
            <div className="text-center">
              <div className="w-24 h-24 bg-blue-500 rounded-full mb-4 flex items-center justify-center text-white text-4xl">
                👩
              </div>
              <div className="text-yellow-400 text-3xl">
                <StarFilled />
              </div>
            </div>
            
            {/* Person 2 */}
            <div className="text-center">
              <div className="w-24 h-24 bg-blue-600 rounded-full mb-4 flex items-center justify-center text-white text-4xl">
                👨
              </div>
              <div className="text-yellow-400 text-3xl">
                <StarFilled />
              </div>
            </div>
          </div>
          
          {/* Floating Stars */}
          <div className="flex justify-center gap-2 text-yellow-400">
            <StarFilled className="text-xl" />
            <StarFilled className="text-2xl" />
            <StarFilled className="text-xl" />
          </div>
        </div>
        
        {/* Decorative Leaves */}
        <div className="absolute bottom-0 left-0 opacity-10">
          <svg width="200" height="200" viewBox="0 0 200 200">
            <path d="M100,180 Q80,140 60,120 Q40,100 60,80 Q80,60 100,80 Q120,60 140,80 Q160,100 140,120 Q120,140 100,180" fill="currentColor" className="text-gray-400"/>
          </svg>
        </div>
      </div>

      {/* Right Side - Login Form */}
      <div className="flex-1 lg:w-1/2 flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-md">
          {/* Logo/Branding */}
          <div className="mb-8 text-center">
            <h1 className="text-2xl block font-bold text-gray-800 mb-2">
              <span className="text-[#0053ce]">RMS</span>
            </h1>
            {/* <p className="text-sm font-medium">
              Reputation Management System
            </p> */}
          </div>

          {/* Login Form Card */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
